import { defineStore } from "pinia";

export const useDateFormat = defineStore("dateFormat", {
  state: () => ({ format: null }),
  getters: {
    dateFormat(state) {
      if (this.format) {
        return state.format.toUpperCase() === "US"
          ? "MM/DD/YYYY"
          : "DD/MM/YYYY";
      }
      return null;
    },

    timeFormats(state) {
      if (!state.format) return null;

      return state.format.toUpperCase() === "US"
        ? { full: "hh:mm:ss A", short: "hh:mm A", hours: "hh A" }
        : { full: "HH:mm:ss", short: "HH:mm", hours: "HH" };
    },
  },

  actions: {
    setDateFormat(format) {
      this.format = format;
    },
  },
});
